/**Описание рабочей области */
export class NamespaceRelationModel {
  /**Идентификатор */
  Id?: string;
  /**Имя */
  Name?: string;
  /**Цвет */
  Color?: string;
  /**Ссылка на иконку */
  Icon: string;

  constructor(obj?: Partial<NamespaceRelationModel>) {
    if (obj) Object.assign(this, obj);
  }
}
